<template>
    <div class="product-link">
        <h2 class="subtitle">Categories</h2>
        <div>
            <div v-if="productCategories.length < 1">
                This product does not belong to a category
                <br/>
            </div>
            <div v-for="category in productCategories">
                <router-link :to="{ name: 'category', params: {id: category.id}}">
                    {{ category.name }}
                </router-link>
                <a class="delete" @click="remove(category)"></a>
            </div>
        </div>
        <br/>
        <div v-if="!adding">
            <a class="button is-small" @click="adding = true">Add to category...</a>
        </div>
        <div v-if="adding">
            <p class="control">
                <span class="select">
                    <select name="category-add" @change="add($event.target.value)">
                        <option>Select a category...</option>
                        <option v-for="category in availableCategories" :value="category.id">{{ category.name }}</option>
                    </select>
                </span>
                <button type="button" class="button" @click="adding = false">Cancel</button>
            </p>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import {CREATE_PRODUCT_CATEGORY, DELETE_PRODUCT_CATEGORY} from "../../store/mutation-types"
    export default {
        props: ['productId'],
        data() {
            return {
                adding: false,
            }
        },
        computed: Object.assign({}, mapGetters(['categories']), {
            availableCategories () {
                let categories = this.$store.state.products.product_categories.filter(category => category.product_id === this.productId)
                let ids        = []
                for (let category in categories) {
                    ids.push(categories[category].category_id)
                }
                return this.categories.filter(category => ids.indexOf(category.id) === -1).sort((a, b) => {
                    a       = a.name
                    b       = b.name
                    let reA = /[^a-zA-Z]/g;
                    let reN = /[^0-9]/g;
                    let aA  = a.replace(reA, "");
                    let bA  = b.replace(reA, "");
                    if (aA === bA) {
                        let aN = parseInt(a.replace(reN, ""), 10);
                        let bN = parseInt(b.replace(reN, ""), 10);
                        return aN === bN ? 0 : aN > bN ? 1 : -1;
                    } else {
                        return aA > bA ? 1 : -1;
                    }
                })
            },
            productCategories () {
                let categories = this.$store.state.products.product_categories.filter(category => category.product_id === this.productId)
                let ids        = []
                for (let category in categories) {
                    ids.push(categories[category].category_id)
                }
                return this.categories.filter(category => ids.indexOf(category.id) !== -1).map(category => {
                    return Object.assign(category, {
                        link_id: categories.find(c => c.category_id === category.id).id
                    })
                })
            }
        }),
        methods: {
            add(category) {
                this.$store.dispatch(CREATE_PRODUCT_CATEGORY, {
                    product_id: this.productId,
                    category_id: category
                })
                this.adding = false
            },
            remove(category) {
                this.$store.dispatch(DELETE_PRODUCT_CATEGORY, {
                    id: category.link_id,
                    product_id: this.productId,
                    category_id: category.id,
                })
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ProductCategories.vue?67a28156